<template>
  <div>
    <MainHeader />
    <div class="timeline-container">
      <div class="entry-list">
        <div class="infor-list">
          <div class="content-flag">
            <div class="common-empty">
              <img src="@/assets/img/published.png">
            </div>
            <div class="published-ok">发布成功！等待管理员审核！</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { onMounted } from "vue";
import MainHeader from "@/components/main-header.vue";

onMounted(async () => {
  console.log("coming in");
});
</script>

<style scoped>
/* 内容区 */
.timeline-container {
  display: flex;
  justify-content: space-between;
  max-width: 800px;
  margin: 20px auto;
}
.entry-list {
  padding: 12px 20px;
  border-radius: 8px 8px 0 0;
  background: #fff;
  min-width: 800px;
  min-height: 725px;
}
/*信息流 */
.infor-list {
  font-size: 16px;
  line-height: 26px;
  padding: 10px 0 20px;
}
.content-flag {
  font-size: 16px;
  font-weight: 400;
  color: #8a919f;
  margin-top:50px;
}
.published-ok {
  text-align: center;
  font-size: 14px;
  line-height: 22px;
  margin-top: 8px;
  color: #4e5969;
}
.common-empty {
	display: flex;
	justify-content: center;
	margin-bottom: 8px;
}
</style>
